export const SET_TENANT_ACTION = 'SYSTEM.SET_TENANT_ACTION';
